<template>
    <div>
        <div class="hidden text-slate-900 text-xs font-semibold grid-cols-12 gap-2 px-6 py-4 w-[calc(100%-5rem)] md:grid">
            <div class="col-span-4">
                Number
            </div>
            <div class="col-span-2">
                State
            </div>
            <div class="col-span-3">
                City
            </div>
            <div class="col-span-3">
                Zip
            </div>
        </div>
        <div v-if="props.list.length"
            class="border border-solid border-slate-200 rounded-lg">
            <search-phone-number-row v-for="phoneNumber in list"
                :key="phoneNumber.phone_number"
                @selected="emit('selected', $event)"
                :phone-number="phoneNumber"></search-phone-number-row>
        </div>
    </div>
</template>

<script setup>
import SearchPhoneNumberRow from './SearchPhoneNumberRow.vue';

const emit = defineEmits(['selected']);

const props = defineProps({
    list: {
        type: Array,
        required: false,
        default: () => [],
    },
});
</script>
